export const ACTION_TYPES = {
  CLEAR_ERROR: "CLEAR_ERROR",
  CLEAR_BREADCRUMBS_RENDER_DATA: "CLEAR_BREADCRUMBS_RENDER_DATA",
  UPDATE_BREADCRUMB_DATA: "UPDATE_BREADCRUMB_DATA",
  UPDATE_BREADCRUMBS_LANIDS: "UPDATE_BREADCRUMBS_LANIDS",
  UPDATE_CURRENTDATE_BREADCRUMB_KEYS: "UPDATE_CURRENTDATE_BREADCRUMB_KEYS",
  UPDATE_ERROR: "UPDATE_ERROR",
  UPDATE_EVENTLOG_DATA: "UPDATE_EVENTLOG_DATA",
  UPDATE_LOADING: "UPDATE_LOADING",
  UPDATE_SELECTED_BREADCRUMB_LANID: "UPDATE_SELECTED_BREADCRUMB_LANID",
  UPDATE_SELECTED_BREADCRUMB_KEY: "UPDATE_SELECTED_BREADCRUMB_KEY",
  UPDATE_SELECTED_EVENTDATE: "UPDATE_SELECTED_EVENTDATE",
};
